<nav class="fuse-menu-layout">
    <div class="fuse-vertical-navigation">
        <div class="fuse-vertical-navigation-wrapper">
            <!-- Header -->
            <div class="fuse-vertical-navigation-header"></div>

            <!-- Content -->
            <div class="fuse-vertical-navigation-content">

                <!-- Content header -->
                <div class="fuse-vertical-navigation-content-header flex justify-center items-center relative">
                    <div class="fuse-logo flex items-center px-4 py-2">
                        <img *ngIf="institutionLogo" [src]="institutionLogo" alt="Logo Institución"
                            class="h-20 w-auto object-contain">
                    </div>
                    <div class="flex items-center p-4 md:hidden absolute right-0">
                        <button matIconButton aria-label="Cerrar menu" (click)="onCloseMenu()">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>

                </div>

                <!-- Items -->
                @for (item of navigation; track $index) {

                <!-- Group -->
                <ng-container *ngIf="item.type === 'group'">
                    <fuse-vertical-navigation-group-item [item]="item" [name]="name" [autoCollapse]="autoCollapse">
                    </fuse-vertical-navigation-group-item>
                </ng-container>

                }


                <!-- <div class="fuse-vertical-navigation-group-item">
                    @for (item of menu; track $index) {
                    <ng-container>

                        @if (item.nameGrupo) {
                        <div class="fuse-vertical-navigation-item-wrapper fuse-vertical-navigation-item-has-subtitle">
                            <div class="fuse-vertical-navigation-item">

                                <div class="fuse-vertical-navigation-item-title-wrapper">
                                    <div class="fuse-vertical-navigation-item-title">
                                        <span> {{item.nameGrupo}} </span>
                                    </div>
                                    <div class="fuse-vertical-navigation-item-subtitle text-gray-100	">
                                        <span> {{item.descGrupo}} </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }

                        @for (subItem of item.submenu; track $index) {
                        <ng-container>
                            @if(subItem.type == _const.TIPO_MENU_BASIC) {
                            <div class="fuse-vertical-navigation-basic-item">
                                <div class="fuse-vertical-navigation-item-wrapper">
                                    <a class="mat-mdc-tooltip-trigger fuse-vertical-navigation-item"
                                        [class]="{'fuse-vertical-navigation-item-active': subItem.active}"
                                        (click)="onActiveMenu(subItem)" [routerLink]="subItem.link">

                                        <mat-icon class="fuse-vertical-navigation-item-icon"
                                            [svgIcon]="subItem.nameIcon"></mat-icon>

                                        <div class="fuse-vertical-navigation-item-title-wrapper">
                                            <div class="fuse-vertical-navigation-item-title">
                                                <span> {{subItem.name}} </span>
                                            </div>
                                        </div>

                                    </a>
                                </div>
                            </div>
                            } @else if(subItem.type == _const.TIPO_MENU_COLLAPSABLE) {
                            <div class="fuse-vertical-navigation-collapsable-item" [class]="{
                                'fuse-vertical-navigation-item-expanded': subItem.expanded,
                                'fuse-vertical-navigation-item-collapsed': !subItem.expanded}">

                                <div class="fuse-vertical-navigation-item-wrapper" (click)="onExpandedMenu(subItem)">
                                    <div class="mat-mdc-tooltip-trigger fuse-vertical-navigation-item">

                                        <mat-icon class="fuse-vertical-navigation-item-icon"
                                            [svgIcon]="subItem.nameIcon"></mat-icon>

                                        <div class="fuse-vertical-navigation-item-title-wrapper">
                                            <div class="fuse-vertical-navigation-item-title">
                                                <span> {{subItem.name}} </span>
                                            </div>
                                        </div>
                                        <div
                                            class="mat-icon fuse-vertical-navigation-item-arrow icon-size-4 mat-icon-no-color">
                                            <mat-icon class="fuse-vertical-navigation-item-arrow icon-size-4"
                                                [svgIcon]="'heroicons_solid:chevron-right'"></mat-icon>

                                        </div>
                                    </div>
                                </div>

                                @if (subItem.expanded) {
                                <div class="fuse-vertical-navigation-item-children animation-expandCollapse">

                                    @for (subItemNivel2 of subItem.submenu; track $index) {
                                    <div class="fuse-vertical-navigation-basic-item">
                                        <div class="fuse-vertical-navigation-item-wrapper">


                                            <a class="mat-mdc-tooltip-trigger fuse-vertical-navigation-item"
                                                [class]="{'fuse-vertical-navigation-item-active': subItemNivel2.active}"
                                                (click)="onActiveMenu(subItemNivel2)" [routerLink]="subItemNivel2.link">
                                                <div class="fuse-vertical-navigation-item-title-wrapper">
                                                    <div class="fuse-vertical-navigation-item-title">
                                                        <span> {{subItemNivel2.name}} </span>
                                                    </div>
                                                </div>
                                            </a>


                                        </div>
                                    </div>
                                    }
                                </div>
                                }


                            </div>
                            }
                        </ng-container>
                        }
                    </ng-container>
                    }

                </div> -->

                <!-- <div class="fuse-vertical-navigation-divider-item">
                    <div class="fuse-vertical-navigation-item-wrapper divider"></div>
                </div> -->

            </div>

            <!-- Footer -->
            <div
                class="fuse-vertical-navigation-footer p-4 flex items-center justify-center border-t border-slate-200/10">
                <img [src]="auroraLogo" alt="Logo Aurora"
                    class="h-20 opacity-50 hover:opacity-100 transition-opacity duration-300">
            </div>

        </div>
    </div>
</nav>